var USER = 'user';

/**
 * User was loaded
 */
var USER_LOADED = "".concat(USER, "/loaded");
export {
// eslint-disable-next-line import/prefer-default-export
USER_LOADED };